<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-14 15:00:02
 * @LastEditTime: 2021-10-14 10:55:26
-->
<template>
  <div class="select-app">
    <van-cell
      title="App"
      is-link
      :style="appId ? 'padding:6px 10px;' : ''"
      @click="choseApp"
    >
      <template #value>
        <AppItem v-if="appId&&appId!=='no'" :data="appInfo" class="app-info justify-end"/>
        <span
          v-else-if="pageType === 'keyword'"
          style="color: #999;"
        >Click Add Your App</span>
        <span v-else-if="appId==='no'&&orderType==='aso'" class="text">(no app)</span>
        <span v-else class="text">All</span>
      </template>
    </van-cell>
    <hr class="select-status-bottom">
    
    <transition name="slide">
      <MyApps
        ref="myApp"
        :platform="platform"
        :page-type="pageType"
        :orderType="orderType"
        @handleChange="showApp"
      />
    </transition>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import MyApps from 'views/campaign/MyApps.vue'
import { useStore } from 'vuex'
export default {
  components: {
    MyApps,
  },
  props: {
    appId: {
      type: String,
      default: null,
    },
    platform: {
      type: Number,
      default: null,
    },
    pageType: {
      type: String,
      default: null,
    },
    appDetail:{
      type: Object,
      default: ()=>null,
    },
    appFirst:{
      type: Object,
      default: ()=>null,
    },
    orderType:{
      type: String,
      default: null,
    }
  },
  setup(props, { emit }) {
    const store = useStore()
    const appInfo = reactive({})
    //数据回显，在父组件执行
    const appInfoInit=()=>{
      Object.assign(appInfo,props.appDetail)
    }
    //默认appid数据回显
    const getAppFirst=()=>{
      Object.assign(appInfo,props.appFirst)
    }
    
    // 选择your apps
    const myApp = ref(null)
    const choseApp = () => {
      myApp.value.open()
    }
    // 回显数据app数据
    const orderForm = store.state.order.order
    const showApp = (val) => {
      Object.assign(appInfo, val==='no'?null:val)
      if (props.pageType === 'order') {
        if(val==='no'){
          store.commit('order/setOrderAppId', val)
        }else{
          store.commit('order/setOrderAppId', val.id)
        }
        if (orderForm.region) {
          store.commit('order/setOrderRegion', null)
        }
      }
      emit('getAppInfo', val)
    }
    return {
      myApp,
      appInfo,
      choseApp,
      showApp,
      orderForm,
      appInfoInit,
      getAppFirst
    }
  },
}
</script>

<style scoped lang="scss">
.select-app {
  .van-cell {
    padding: 8px 10px;

    &::after {
      left: 10px;
      right: 10px;
    }

    :deep(.van-cell__title) {
      color: #1e183f;
      font-weight: bold;
    }

    :deep(.van-cell__value) {
      font-size: 13px;

      .text {
        color: #1e183f;
      }

      .li {
        padding: 0;
        margin-top: 0;
      }
    }
  }

  .select-status-bottom {
    height: 0;
    border: none;
    position: absolute;
    border-top: 1px solid #ebeef5;
  }
}
</style>
